import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { isFastly } from "@faire/web--source/common/images/optimizeImages";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
// Helper function for checking if an image url (i.e. external url)
// is accessible and returns a valid response, and not 4xx/5xx.
var checkValidImage = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(image) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var _getWindow;
                    var imageUrl = image.url;
                    var ImgConstructor = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.Image;
                    if (!imageUrl) {
                        reject(undefined);
                    } else if (isFastly(imageUrl) || ImgConstructor === undefined) {
                        // if internal url, assume link is safe OR if in a non-browser environment
                        resolve(image);
                    } else {
                        var img = new ImgConstructor();
                        img.src = imageUrl;
                        img.onload = function() {
                            return resolve(image);
                        };
                        img.onerror = function() {
                            reject(undefined);
                        };
                    }
                }).catch(function() {
                    return undefined;
                })
            ];
        });
    });
    return function checkValidImage(image) {
        return _ref.apply(this, arguments);
    };
}();
export var filterInvalidImages = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(images) {
        var result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(images.map(function(image) {
                            return checkValidImage(image);
                        }))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.filter(isNotUndefined)
                    ];
            }
        });
    });
    return function filterInvalidImages(images) {
        return _ref.apply(this, arguments);
    };
}();
